export const defaultSeoFocus = [
  { name: 'Arquitetura' },
  { name: 'Conteúdo' },
  { name: 'Dados' },
  { name: 'Geral' },
  { name: 'Tecnologia' },
  { name: 'Usabilidade' },
  { name: 'Velocidade' },
  { name: 'Mercado' },
];
